(function($) {

	'use strict';

	var init = function() {

        $('.btn-secondary').parent('p').addClass('btnWrapp')

	};

	$(document).ready(function() {
        init();
	});

})(jQuery);
